<template>
  <div class="coupon-warp" v-if="usableItems&&usableItems.length">
    <div class="coupon-items">
      <div class="coupon-item" v-for="coupon in usableItems" :key="coupon.activityCode+coupon.couponTemplateCode" @click="doGetCoupon(coupon)" :class="{isUsedBg:coupon.displayType === '2' && coupon.couponFinishUsingType === '1'}">
        <div class="coupon-info">
          <!-- <h4><span>￥</span>{{coupon.couponValue}}</h4> -->
          <coupon-value-label :couponData="coupon" :forHomePage="true" :couponValue='coupon.couponValue' :couponType='coupon.couponType' :textColor="(coupon.displayType == 2 && coupon.couponFinishUsingType === '1') ? '#999999' : ''"></coupon-value-label>
          <template v-if="coupon.couponType!=='REALITY_GIFT_COUPON'">
            <h5>{{coupon.description}}</h5>
            <p>{{coupon.couponTemplateName}}</p>
          </template>
        </div>
        <!-- <div class="coupon-btn">{{coupon.displayType == 2 ? '去 使 用' : '领 取'}}</div> -->
        <div class="coupon-btn" v-if="coupon.displayType == 2">
          {{coupon.couponFinishUsingType === '1' ? '已 使 用' : '去 使 用'}}
        </div>
        <div class="coupon-btn" v-else>
          领 取
        </div>
        <div class="coupon-status" v-if="coupon.displayType == 2 && coupon.couponFinishUsingType !== '1'"></div>
      </div>
      <div class="coupon-more" @click="more()">
        <i></i>
        <p>查看更多</p>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../api';
import couponValueLabel from '@/components/couponValueLabel'

export default {
  name: 'couponItems',
  components: { couponValueLabel },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    usableItems() {
      return this.items.filter(item => item.displayType !== '5' && item.displayType !== 5)
    }
  },
  methods: {
    doGetCoupon(item) {
      if (Number(item.displayType) === 2) {
        this.$router.push(`/usablecouponlist?couponTemplateCode=${item.couponTemplateCode}&activityCode=${item.activityCode}&couponType=${item.couponType}&sourceChannel=${item.sourceChannel}`)
      } else {
        if (this.$store.state.isLogin) {
          const streetId = this.$store.getters['getlocationInfo'].townshipId;
          Api.getCouponItem({
            activityCode: item.activityCode,
            couponTemplateCode: item.couponTemplateCode,
            sourceChannel: item.sourceChannel,
            streetId
            // couponFrom: item.couponFrom || '',
          }).then(res => {
            let result = res.data
            console.log(result)
            if (result.success && result.data.couponCode) {
              item.displayType = 2
            } else {
              this.$toast(result.message)
            }
          })
        } else {
          // this.$router.push('/login')
          this.$store.dispatch('doLogin');
        }
      }
    },
    more() {
      this.$router.push(`/voucher`)
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-info :deep(.container) {
  height:0.42rem;
}
.coupon-warp{
  margin: .12rem .32rem .24rem .32rem;
  // margin-top: .1rem;
  height: 1.68rem;
  padding: .17rem .2rem;
  background: rgba(255,255,255,0.9);
  border-radius: .24rem;
  box-sizing: border-box;
  overflow: hidden;
  @include synShadow;
}

.coupon-items{
  height: 2rem;
  overflow-x: auto;
  white-space: nowrap;
}

.coupon-item{
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 2.4rem;
  height: 1.34rem;
  margin-right: .16rem;
  padding: 0 .16rem;
  box-sizing: border-box;
  background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/coupon_bg.png) no-repeat;
  background-size: cover;
  vertical-align: top;
  overflow: hidden;
  &:last-child{
    margin-right: 0;
  }
}
.isUsedBg {
  background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/shop/isUsed_shop_coupon_bg.png) no-repeat;
  background-size: 2.4rem 1.34rem;
  .coupon-info{
    h5{
      color: #999999;
    }
    p{
      color: #999999;
    }
  }
  .coupon-btn{
    margin-left: .15rem;
  }
}
.coupon-info{
  width: 1.75rem;
  h4{
    font-size: .4rem;
    line-height: .4rem;
    font-weight: 500;
    color: #FF500E;
    @include text-overflow(1);
    span{
      font-size: .28rem;
      font-weight: 400;
    }
  }
  h5{
    font-size: .22rem;
    line-height: .32rem;
    color: #FF500E;
    @include text-overflow(1);
  }
  p{
    font-size: .18rem;
    line-height: .26rem;
    color: #FF500E;
    @include text-overflow(1);
  }
}

.coupon-btn{
  width: .28rem;
  color: #fff;
  font-size: .28rem;
  opacity: .9;
  line-height: .4rem;
  word-break: break-all;
  writing-mode: vertical-rl;
  z-index: 3;
}

.coupon-status{
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 2;
  width: .86rem;
  height: .79rem;
  background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/coupon_disable.png) no-repeat;
  background-size: cover;
}

.coupon-more{
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 1.34rem;
  padding: 0 .1rem;
  vertical-align: top;
  i{
    display: block;
    width: .48rem;
    height: .48rem;
    background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/more.png) no-repeat;
    background-size: cover;
  }
  p{
    margin-top: .08rem;
    font-size: .24rem;
    color: #999;
    line-height: .36rem;
  }
}

</style>
